import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
import Link from "../Link";

export type DropDownMenuItemProps = {
  key: string;
  children: React.ReactNode;
  url?: string;
  disabled?: boolean;
  items?: DropDownMenuItemProps[];
  onClick?: () => void;
};

const DropDownMenuItem = ({
  children,
  url,
  disabled = false,
  onClick,
}: DropDownMenuItemProps) => (
  <RadixDropdownMenu.Item
    className="DropdownMenuItem cursor-pointer py-1 relative"
    disabled={disabled}
    onClick={onClick}
  >
    {children}
    {url && !onClick && ( // Eğer hem url hem de onClick yoksa sadece Link oluşturuluyor
      <Link className="absolute top-0 left-0 h-full w-full" href={url} />
    )}
  </RadixDropdownMenu.Item>
);

export default DropDownMenuItem;
